module.exports = __webpack_public_path__ + "static/img/uranium_256.a83b220.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/uranium_256.png
// module id = eRXl
// module chunks = 0